<template>
  <t-form :data="formComponent" :rules="rulesComponent" ref="formComponent" @submit.native.prevent label-width="100px">
    <t-form-item label="组件名称" name="name">
      <t-input v-model="formComponent.name"></t-input>
    </t-form-item>
    <t-form-item label="选择看板" name="boardId">
      <t-select v-model="formComponent.boardId" filterable :disabled="!!propBoardId" placeholder="请选择">
        <t-option v-for="item in boardListCal" :key="item.key" :label="item.label" :value="item.value"></t-option>
      </t-select>
      <div style="display: inline-block; color: orange" v-show="!loadingBoardList && !boardListCal.length">
        <icon name="error-circle" />
        你还没有看板，先去自定义看板中新建一个吧
      </div>
    </t-form-item>

    <t-form-item label="图表样式" name="chartType">
      <t-radio-group v-model="formComponent.chartType" size="medium" @change="handleChartTypeChange">
        <t-radio-button
          v-for="item in chartTypeListCal"
          :value="item.value"
          :disabled="item.disabled"
          :key="item.value"
        >
          {{ item.label }}
        </t-radio-button>
      </t-radio-group>
    </t-form-item>
    <t-form-item label="组件规格" name="size">
      <t-radio-group v-model="formComponent.size" size="medium">
        <t-radio-button v-for="item in sizeListCal" :value="item.value" :disabled="item.disabled" :key="item.value">
          {{ item.label }}
        </t-radio-button>
      </t-radio-group>
    </t-form-item>

    <t-form-item label="组件备注" name="remark" key="remark">
      <t-textarea v-model="formComponent.remark"></t-textarea>
    </t-form-item>
  </t-form>
</template>

<script>
import { pick } from 'lodash';
import { CHART_TYPE } from '@/utils/config';
import { getGroupList } from '@/api/analysis/custom-overview';

export default {
  name: 'event-analysis-save-component-form',
  props: {
    saveType: {
      type: String,
      required: true,
    },
    boardInfo: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingBoardList: true,
      boardList: [],
      chartTypeList: [
        { label: '表格', value: CHART_TYPE.TABLE },
        { label: '柱状图', value: CHART_TYPE.HISTOGRAM },
        { label: '环形图', value: CHART_TYPE.CIRCULAR_GRAPH },
      ],
      disabledChartTypeList: [],
      sizeList: [
        // { label: '小卡片(1*1)', value: 'small' },
        { label: '中卡片(2*2)', value: 'middle' },
        { label: '中卡片(2*3)', value: 'middle23' },
        { label: '大卡片(4*3)', value: 'large' },
      ],
      disabledSizeList: [],
      zbIndexList: [
        // { label: '请选择', value: '' },
        { label: '合计值', value: 'total' },
        { label: '均值', value: 'mean' },
        { label: '最近一天的值', value: 'latest_day' },
      ],
      topNOptions: [
        { label: '前5项', value: 5 },
        { label: '前10项', value: 10 },
        { label: '前20项', value: 20 },
        { label: '前30项', value: 30 },
        { label: '前40项', value: 40 },
        { label: '前50项', value: 50 },
      ],
      dimensionTypeList: [
        { label: '按天展示', value: 'day' },
        { label: '合计值', value: 'total' },
      ],

      propBoardId: '',
      formComponent: {
        id: '',
        name: '',
        boardId: '',
        chartType: '',
        size: '',
        indexTabDisplay: 1,
        indexSet: 'people',
        primaryIndex: '',
        secondaryIndex: [],
        lineCount: 0,
        dimensionType: '',
        remark: '',
        ext: '',
      },
      rulesComponent: {
        name: [
          { required: true, message: '请输入组件名称', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' },
        ],
        boardId: [{ required: true, message: '请选择看板', trigger: 'blur' }],
        chartType: [{ required: true, message: '请选择图表样式', trigger: 'blur' }],
        size: [{ required: true, message: '请选择组件规格', trigger: 'blur' }],
        indexSet: [{ validator: this.validateIndexSet, trigger: 'blur' }],
        primaryIndex: [{ required: true, message: '请选择主展示指标', trigger: 'blur' }],
        lineCount: [{ required: true, message: '请输入展示条数', trigger: 'blur' }],
        dimensionType: [{ required: true, message: '请选择展示维度', trigger: 'blur' }],
        remark: [{ min: 1, max: 140, message: '长度在 1 到 140 个字符', trigger: 'blur' }],
      },
    };
  },
  computed: {
    isNumber() {
      return [CHART_TYPE.NUMBER_TYPE].includes(this.formComponent.chartType);
    },
    isChartLine() {
      return [CHART_TYPE.CHART_LINE].includes(this.formComponent.chartType);
    },
    isTable() {
      return [CHART_TYPE.TABLE].includes(this.formComponent.chartType);
    },
    chartTypeListCal() {
      return this.chartTypeList.map(item => {
        const nItem = {
          ...item,
          disabled: false,
        };
        if (this.disabledChartTypeList.includes(nItem.value)) {
          nItem.disabled = true;
        }
        return nItem;
      });
    },
    sizeListCal() {
      const { chartType } = this.formComponent;
      return this.sizeList.map(item => {
        const nItem = {
          ...item,
          disabled: false,
        };
        if (chartType === CHART_TYPE.TABLE) {
          // 表格时，只能选择大卡 4*3
          if (nItem.value !== 'large') {
            nItem.disabled = true;
          }
        }
        return nItem;
      });
    },
    zbIndexListCal() {
      return this.zbIndexList
        .filter(item => item.value !== '')
        .map(item => ({
          ...item,
          disabled: item.value === this.formComponent.primaryIndex,
        }));
    },
    boardListCal() {
      if (this.propBoardId) {
        return [...this.boardList, { label: this.boardInfo.name, value: this.propBoardId, key: 'prop-board' }];
      }
      return this.boardList;
    },
  },
  created() {
    this.propBoardId = this.form.boardId; // 设置属性带过来的看板id
    const tmpForm = pick(this.form, [
      'id',
      'name',
      'boardId',
      'chartType',
      'size',
      'indexTabDisplay',
      'indexSet',
      'lineCount',
      'dimensionType',
      'remark',
      'ext',
    ]);
    if (tmpForm.secondaryIndex && typeof tmpForm.secondaryIndex === 'string') {
      tmpForm.secondaryIndex = tmpForm.secondaryIndex.split(',');
    }
    if (Array.isArray(tmpForm.indexSet) && tmpForm.indexSet.length) {
      tmpForm.indexSet = tmpForm.indexSet.map(i => i.targetName).join('');
    }

    // 目前折线图，是一定要选分tab
    if (tmpForm.chartType === CHART_TYPE.CHART_LINE) {
      tmpForm.indexTabDisplay = 1;
      if (!tmpForm.indexSet) {
        tmpForm.indexSet = 'people';
      }
    }

    Object.assign(this.formComponent, tmpForm);

    if (!this.formComponent.lineCount) {
      this.formComponent.lineCount = 5;
    }
    if (!this.formComponent.dimensionType) {
      this.formComponent.dimensionType = 'day';
    }
    this.setChartTypeAndSize();

    // if (this.propBoardId) {
    //   this.boardList = [{ label: this.boardInfo.name, value: this.propBoardId }];
    // }
    this.handleGetBoardList();
  },
  methods: {
    async handleGetBoardList() {
      try {
        this.loadingBoardList = true;
        const res = await getGroupList({ params: { groupType: 0, isShowBoard: true } });
        const arr = [];
        res.forEach(groupItem => {
          if (groupItem.boardList) {
            groupItem.boardList.forEach(boardItem => {
              arr.push({
                label: boardItem.name,
                value: boardItem.id,
                key: `${groupItem.id}-${boardItem.id}`,
              });
            });
          }
        });
        this.boardList = arr;
      } finally {
        this.loadingBoardList = false;
      }
    },

    handleChartTypeChange() {
      const { chartType, size } = this.formComponent;
      const validSizeList = this.sizeListCal.filter(item => !item.disabled);
      if (validSizeList.findIndex(item => item.value === size) === -1) {
        this.formComponent.size = validSizeList[0].value;
      }
      if (chartType === CHART_TYPE.CHART_LINE) {
        this.formComponent.indexTabDisplay = 1;
        this.formComponent.indexSet = this.formComponent.indexSet || 'people';
      }
    },

    handlePrimaryIndexChange() {
      if (Array.isArray(this.formComponent.secondaryIndex)) {
        const idx = this.formComponent.secondaryIndex.findIndex(item => item === this.formComponent.primaryIndex);
        if (idx >= 0) {
          this.formComponent.secondaryIndex.splice(idx, 1);
        }
      }
    },

    setChartTypeAndSize() {
      // const weiduList = this.shuxingWeiduList.filter(item => item.val !== 'all');
      // let isSingle = false;
      // if (this.zhibiaoList.length === 1 && weiduList.length === 0) {
      //   isSingle = true;
      // }
      // if (!isSingle) {
      //   this.disabledChartTypeList = ['number'];
      //   // this.disabledSizeList = ['small'];
      // }
      // 暂时只支持表格
      this.disabledChartTypeList = [CHART_TYPE.HISTOGRAM, CHART_TYPE.CIRCULAR_GRAPH];
    },

    validate() {
      return this.$refs.formComponent.validate();
    },

    resetFields() {
      this.$refs.formComponent.reset();
    },

    getForm() {
      return JSON.parse(JSON.stringify(this.formComponent));
    },

    validateIndexSet(value) {
      if (this.formComponent.indexTabDisplay === 1 && value.length === 0) {
        return { result: false, message: '请选择至少一个指标', type: 'error' };
      }
      return { result: true, message: '', type: 'success' };
    },
  },
};
</script>

<style scoped></style>
